import { useMemo as s } from "react";
const u = (t, n) => {
  typeof t == "function" ? t(n) : t && (t.current = n);
}, e = (t, n) => s(() => t == null && n == null ? null : (o) => {
  u(t, o), u(n, o);
}, [t, n]);
export {
  e as default
};
//# sourceMappingURL=useForkRef.js.map
